import React, { useEffect, useRef, useState } from 'react';

type Props = {
  onScrollOver: () => void;
}
export function InfiniteScroll ({ onScrollOver }: Props) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isScrollingOver, setIsScrollingOver] = useState(false);

  useEffect(() => {
    if (IntersectionObserver && containerRef.current) {
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setIsScrollingOver(true);

          // setting a timeout prevents the illusion that everything is loaded at once (which might lead someone to
          // try and Ctrl+F to find what they're looking for)
          setTimeout(() => {
            onScrollOver();
            setIsScrollingOver(false);
          }, 500);
        }
      });
      observer.observe(containerRef.current);

      return () => {
        if (containerRef.current) {
          observer.unobserve(containerRef.current);
        }
      };
    }
  }, [onScrollOver, containerRef]);

  return (
    <div className="flex justify-center my-4" ref={containerRef}>
      {isScrollingOver ? 'Loading more...' : (
        // Button should still exist for browsers that don't support intersection observer (and screen readers)
        <button
          className="text-gray-800 border-b border-gray-800"
          onClick={onScrollOver}
        >
          Load more
        </button>
      )}
    </div>
  );
}
